import React from "react";
import { useIntl } from "react-intl";
import { IProps } from "./types";

import messages from '../../dashboard/Meta/Details/messages';
import generalMessages from '../../dashboard/Meta/General/messages';
import { getIconedDetail, getLabel } from "../Components/IconedDetail";
import { choirConcertConditionsOptions, choirConcertFrequencyOptions, choirProficiencyLevelOptions } from "../../../consts/meta/details";
import { CheckboxThreeWay, Label } from "../../../../components/Form";
import { choirGoalOptions, choirWayOfSingingOptions } from "../../../consts/meta/general";
import DisplayData from "../Components/DisplayData";
import { Column, Padding } from "../General/styles";
import { Container } from "./styles";

const Details = ({ choir }: IProps) => {
    const { details, general } = choir.meta;
    const { formatMessage } = useIntl();
    const concertFrequencyValue = getLabel(choirConcertFrequencyOptions, details.concertFrequency);
    const concertFrequency = <DisplayData label={messages.concertFrequency} value={concertFrequencyValue ? [concertFrequencyValue] : []} />
    const concertConditions = <DisplayData label={messages.concertConditions} value={getLabel(choirConcertConditionsOptions, details.concertConditions)} />

    const proficiencyLevelValue = getLabel(choirProficiencyLevelOptions, details.proficiencyLevel);
    const proficiencyLevel = <DisplayData label={messages.proficiencyLevel} value={proficiencyLevelValue ? [proficiencyLevelValue] : []} />

    const goal = <DisplayData label={generalMessages.goal} value={getLabel(choirGoalOptions, general.goal)} />
    const wayOfSingingValue = getLabel(choirWayOfSingingOptions, general.wayOfSinging);
    const wayOfSinging = <DisplayData label={generalMessages.wayOfSinging} value={wayOfSingingValue ? [wayOfSingingValue] : []} />

    return (
        <Container>
            <Padding>
                <Column>
                    {concertFrequency}
                    {concertConditions}
                    {proficiencyLevel}
                    {goal}
                    {wayOfSinging}
                </Column>
                <Column>
                    <CheckboxThreeWay label={formatMessage(generalMessages.forProject)} checked={general.forProject} onChange={() => null} />
                    <CheckboxThreeWay label={formatMessage(generalMessages.acapella)} checked={general.acapella} onChange={() => null} />
                    <CheckboxThreeWay label={formatMessage(messages.choirCamps)} checked={details.choirCamps} onChange={() => null} />
                    <CheckboxThreeWay label={formatMessage(messages.choirWeekEnds)} checked={details.choirWeekEnds} onChange={() => null} />
                    <CheckboxThreeWay label={formatMessage(messages.sectionals)} checked={details.sectionals} onChange={() => null} />
                    <CheckboxThreeWay label={formatMessage(messages.rehearsalPreview)} checked={details.rehearsalPreview} onChange={() => null} />
                    <CheckboxThreeWay label={formatMessage(messages.uniform)} checked={details.uniform} onChange={() => null} />
                </Column>
            </Padding>
        </Container>
    );
};

export default Details;
